<template>
  <v-menu open-on-hover bottom offset-y>
    <template v-slot:activator="{ on, attrs }">
      <v-list-item link v-bind="attrs" v-on="on">
        <v-list-item-avatar tile>
          <v-img src="@/assets/language.png"></v-img>
        </v-list-item-avatar>
        <v-list-item-title v-if="$vuetify.breakpoint.smAndUp">{{
          $t("sideBarLayout.links[4]")
        }}</v-list-item-title>
      </v-list-item>
    </template>

    <v-list>
      <v-list-item
        v-for="(item, index) in items"
        :key="index"
        @click="switchLanguage(item.value)"
      >
        <v-list-item-title>{{ $t(item.title) }}</v-list-item-title>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script>
import { useUXState } from "@/composables/ux.js";
export default {
  setup() {
    const { locale } = useUXState();
    return { locale };
  },
  data: () => ({
    items: [
      { title: "languages.french", value: "fr" },
      { title: "languages.english", value: "en" }
    ]
  }),
  methods: {
    switchLanguage(value) {
      this.$i18n.locale = value;
      this.locale = value;
    }
  }
};
</script>
